import React,{useState,useEffect} from "react";
import footerLogo from "../assets/img/build2.svg";
import ReactHtmlParser from "react-html-parser";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const Footer = ({iletisim}) => {
  const [resultLast, setResultLast] = useState({});

  useEffect(() => {
    if (iletisim && typeof iletisim === 'object') {
      setResultLast(iletisim);
    }
  }, [iletisim]);
  return (
    <div className="footer-main d-flex align-item-center">
      <div className="container text-white align-items-center ">
        <div className="row">
          {" "}
          <div className="col-lg-4 col-md-3 col-12 d-flex justify-content-center flex-column">
            <h5>Hızlı Erişim</h5>
            <ul className="footer-text">
              <a href="/" target="_blank"><li>Anasayfa</li></a> 
              <a href="/duyurular" target="_blank"><li>Duyurular</li></a> 
              <a href="/sakinler" target="_blank"> <li>Sakinler</li></a>
              <a href="/iletisim"target="_blank"><li>İletişim</li></a> 
            </ul>
          </div>
          <div className="col-lg-4 col-md-5 col-12 footer-text d-flex justify-content-center flex-column">
            <h5>İletişim</h5>
            <div className="d-flex mt-1">
              <div className="col-3">
                <h5>Adres:</h5>
              </div>
              <div className="col-9">
                {resultLast.adres ? ReactHtmlParser(resultLast.adres) : '-'}
              </div>
            </div>
            <div className="d-flex mt-2">
              <div className="col-3">
                <h5>Lobi:</h5>
              </div>
              <div className="col-9">
                {resultLast.lobi_tel ? (
                  <a href={`tel:${resultLast.lobi_tel}`}>
                    {resultLast.lobi_tel}
                  </a>
                ) : '-'}
              </div>
            </div>
            <div className="d-flex mt-2">
              <div className="col-3">
                <h5>Yönetim:</h5>
              </div>
              <div className="col-9">
                {resultLast.yonetim_tel ? (
                  <a href={`tel:${resultLast.yonetim_tel}`}>
                    {resultLast.yonetim_tel}
                  </a>
                ) : '-'}
              </div>
            </div>
            <div className="d-flex mt-2">
              <div className="col-3">
                <h5>Email:</h5>
              </div>
              <div className="col-9">
                {resultLast.email ? (
                  <a href={`mailto:${resultLast.email}`}>
                    {resultLast.email}
                  </a>
                ) : '-'}
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-12 d-flex justify-content-end">
            <img src={footerLogo}></img>
          </div>
        </div>

        <div className="row ">
          {" "}
          <div className="col-8  ">
            <p>copyright © {new Date().getFullYear()} | all rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  duyurular: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    iletisim: state.iletisimData.iletisim,
  };
};

export default connect(mapStateToProps)(Footer);
